import script from "./CookiesCardsSizesStyle.vue?vue&type=script&lang=ts"
export * from "./CookiesCardsSizesStyle.vue?vue&type=script&lang=ts"

import "./CookiesCardsSizesStyle.vue?vue&type=style&index=0&id=06ceaed7&lang=css"

const __exports__ = script;

export default __exports__